import type { StateCreator } from 'zustand';
import type { CanvasImage } from '@/utils/canvas/canvasUtils';

import type { CanvasSlice } from './types';

export type { CanvasSlice } from './types';

export const canvasInitialState = {
  canvasImages: [] as CanvasImage[],
};

export const createCanvasSlice: StateCreator<
  CanvasSlice,
  [],
  [],
  CanvasSlice
> = (set) => ({
  ...canvasInitialState,

  setCanvasImages: (canvasImages) => set({ canvasImages }),
});
